import { Component } from 'react';
import { withRouter } from 'react-router-dom';

/**
 * From here: https://stackoverflow.com/a/44992311
 */
class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
